import mitt from 'mitt'

const emitter = mitt()

// export emit and on methods
export const emit = emitter.emit
export const on = emitter.on
export const off = emitter.off
export const all = emitter.all

export default emitter